import { apiClient } from 'utils/apiClient';
import { ApiEndpoints } from 'models/apiEndpoints';
import { isResponseError, TResponse } from 'models/apiClient';
import {
  EDictionaryTypes,
  IDictionaryResponse,
  IDictionarySearchLike,
} from 'models/dictionary';

const languageUniqueId = '34c4897a-29de-4e2a-a624-5bb71ec0e421'; // TODO

const getDictionary = async (type: EDictionaryTypes) => {
  const queryParams: any = new URLSearchParams({
    type,
    languageUniqueId,
  });
  const { data } = await apiClient.get<TResponse<IDictionaryResponse>>(
    ApiEndpoints.GET_DICTIONARY(queryParams),
  );
  if (isResponseError(data)) {
    return null;
  }
  return data;
};

const getDictionaryNamesLike = async (type: EDictionaryTypes, body: IDictionarySearchLike) => {
  const { data } = await apiClient.post<TResponse<{ name: string[] }>>(
    ApiEndpoints.GET_DICTIONARY_LIKE(type),
    body,
  );

  if (isResponseError(data)) {
    return null;
  }
  return data;
};

const getDictionaryPhoneCode = async () => {
  const queryParams: any = new URLSearchParams({
    languageUniqueId,
  });
  const { data } = await apiClient.get<TResponse<IDictionaryResponse>>(
    ApiEndpoints.GET_DICTIONARY_PHONE(queryParams),
  );
  if (isResponseError(data)) {
    return null;
  }
  return data;
};

export { getDictionary, getDictionaryNamesLike, getDictionaryPhoneCode };
